﻿enum ReservationStatusType {
	Undefined,
	Submitted,
	Cancelled,
	Rejected,
	UnderReview,
	Quoted,
	ReSubmitted,
	Active,
	Expired
}

export default ReservationStatusType;
